import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitInitiativesView = createSelector(
  [selectFinancialCockpitState],
  ({ initiativesView }) => initiativesView
)
